import { render, staticRenderFns } from "./Wizardot3characteristics.vue?vue&type=template&id=40eb2c70&"
import script from "./Wizardot3characteristics.vue?vue&type=script&lang=js&"
export * from "./Wizardot3characteristics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports